module.exports = __webpack_public_path__ + "static/media/light-theme-fuel-drop.62743332.svg";